import { retrieveCartReference } from '../libs/helpers'

export const isReady = state => state.cart.isReady
export const hasError = state => state.cart.hasError === true
export const getErrorMessage = state => state.cart.errorMessage
export const getCartReference = state => {
  if (state.cart.reference === '') {
    return retrieveCartReference()
  } else {
    return state.cart.reference
  }
}
export const getCartItems = state => state.cart.items
export const getCartTotal = state => state.cart.total
export const getCartPayNow = state => state.cart.payNow
export const getFocusedPosition = state => state.cart.focusedPosition
export const getCurrentItem = state => {
  if (state.cart.items.length === 0) {
    return null
  }
  return state.cart.items[state.cart.focusedItemId]
}

export const getCartFreeTrial = state => {
  if (state.cart.freeTrial) {
    return {
      status: true,
      type: state.cart.freeTrialType,
      length: state.cart.freeTrialLength
    }
  } else {
    return {
      status: false
    }
  }
}
